exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._272p99Dc9k8js3MdDDDiDs{margin-bottom:20px}._1EP3BQ39teGnFYYBcFutsb{font-size:15px;margin-bottom:5px}._2ImfeJhayiUHGIRtkF_IiO{cursor:pointer}._3esnnsT_jrqYNC1DIBMyvH{background-color:#eee}._2A2lFTXrG4RVvedTxhaC15{font-size:13px;color:#616161;line-height:20px}.R9DKAcfpTFjLNc6hbUG1t{padding:0px}.R9DKAcfpTFjLNc6hbUG1t>._2ImfeJhayiUHGIRtkF_IiO{border-bottom:2px solid #e0e0e0;padding:20px}.R9DKAcfpTFjLNc6hbUG1t>._2ImfeJhayiUHGIRtkF_IiO:last-child{border-bottom:0px}._22oQxfE7ZozrKfq8noLqCb{height:400px;display:flex;flex-flow:column wrap;align-items:center;justify-content:center}.rmRSlrgMUH42-gdiz6NgJ{padding-top:20px}\n", ""]);

// Exports
exports.locals = {
	"newMessage": "_272p99Dc9k8js3MdDDDiDs",
	"content": "_1EP3BQ39teGnFYYBcFutsb",
	"row": "_2ImfeJhayiUHGIRtkF_IiO",
	"hovered": "_3esnnsT_jrqYNC1DIBMyvH",
	"createdAt": "_2A2lFTXrG4RVvedTxhaC15",
	"messages": "R9DKAcfpTFjLNc6hbUG1t",
	"empty": "_22oQxfE7ZozrKfq8noLqCb",
	"explainer": "rmRSlrgMUH42-gdiz6NgJ"
};